<!-- @format -->

<template>
  <div class="row">
    <div class="twelve wide column">
      <div class="ui segment">
        <h3>Portfolio Fee</h3>
        <div class="ui form">
          <div class="field">
            <label>Select Portfolio</label>
            <sui-dropdown
              fluid
              placeholder="Select Portfolio"
              selection
              :options="portfolios"
              v-model="selectedPortfolio"
            />
          </div>
        </div>
        <h3>Fees</h3>
        <table class="ui table" v-if="selectedPortfolio">
          <tbody>
            <tr v-for="advfee in advisoryFees" :key="advfee.index">
              <td style="width: 450px">
                Total investment costs
                {{ advfee.rate | numeralFormat("0.00") }}%
              </td>

              <td>
                <div class="ui labeled input">
                  <div class="ui label">%</div>
                  <vue-numeric
                    v-on:focus="showSaveButton = true"
                    v-model="advfee.rate"
                    :min="0"
                    :step="0.01"
                    :precision="5"
                  ></vue-numeric>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="ui segment">
        <div class="ui large green button" @click="saveFees">
          Save Portfolio Fees
        </div>
        |
        <div class="ui large grey button" @click="initialLoad">Cancel</div>
      </div>
      <div class="ui segment message" v-if="message != ''">{{ message }}</div>
    </div>
  </div>
</template>

<script>
import {
  getPartnerFees,
  savePartnerFees,
  getPortfolioFees,
  savePortfolioFees,
  getPortfolios,
} from "@/gateway";

export default {
  name: "PortfolioFeeTable",
  props: {
    msg: String,
  },
  data() {
    return {
      message: "",
      portfolios: [],
      selectedPortfolio: null,
      showSaveButton: false,
      showModal: false,
      // fees

      avisoryFeeId: 0,
      advisoryFees: [
        {
          index: 0,
          lower: 0,
          upper: 99999999999,
          rate: 0,
        },
      ],
      platformFeeId: 0,
      platformFees: [
        {
          index: 0,
          lower: 0,
          upper: 99999999999,
          rate: 0,
        },
      ],
    };
  },
  methods: {
    async removePlatformFee(indx) {
      let tempFees = this.platformFees;
      let newTempFees = [];
      this.platformFees = [];
      tempFees.forEach(function(d) {
        if (d.index != indx) newTempFees.push(d);
      });
      this.platformFees = newTempFees;
      this.showSaveButton = true;
    },
    async removeAdvisoryFee(indx) {
      let tempFees = this.advisoryFees;
      let newTempFees = [];
      this.advisoryFees = [];
      tempFees.forEach(function(d) {
        if (d.index != indx) newTempFees.push(d);
      });
      this.advisoryFees = newTempFees;
      this.showSaveButton = true;
    },

    async addPlatformFee(indx, lower, upper, rate) {
      this.platformFees.push({
        index: indx,
        lower,
        upper,
        rate,
      });

      this.showSaveButton = true;
    },
    async addAdvisoryFee(indx, lower, upper, rate) {
      this.advisoryFees.push({
        index: indx,
        lower,
        upper,
        rate,
      });
      this.showSaveButton = true;
    },
    async saveFees() {
      // platform fees
      var response = await savePortfolioFees({
        portfolioId: this.selectedPortfolio,
        feeBrackets: this.advisoryFees,
      });

      this.showSaveButton = false;
      this.message = "Successfully saved fees";
      this.initialLoad();
    },
    async getPortfs() {
      this.portfolios = [];
      var response = await getPortfolios();
      response.result.forEach((item) => {
        this.portfolios.push({
          key: item.id,
          text: item.portfolioName,
          value: item.id,
        });
      });
    },
    async getFees(portfolioId) {
      var response = await getPortfolioFees({
        portfolioId: portfolioId,
      });
      let newFees = [];
      let ind = 1;

      response.result[0].bracket.forEach(function(item) {
        newFees.push({
          index: ind,
          lower: item.lower,
          upper: item.upper,
          rate: item.rate,
        });
        ind++;
      });
      {
        this.advisoryFees = newFees;
        this.advisoryFeeId = response.result[0].id;
      }
    },
    async initialLoad() {
      await this.getPortfs();
      //await this.getFees("Platform");
      this.showSaveButton = false;
    },
  },
  async mounted() {
    this.initialLoad();
  },
  watch: {
    selectedPortfolio: function() {
      this.getFees(this.selectedPortfolio);
    },
  },
};
</script>
